module.exports = __webpack_public_path__ + "media/Police_station.3e15bf7a.mp3";